import {ShowController} from 'ra-core';
import React from 'react';
import {ShowView, Tab, TabbedShowLayout, TextField} from 'react-admin';
const AccountShow = (props) => (
  <ShowController {...props}>
    {(controllerProps) => (
      <ShowView {...props} {...controllerProps}>
        <TabbedShowLayout>
          <Tab label="Details">
            <TextField source="id" />
            <TextField source="jobId" label="Job ID" />
            <TextField source="vendorId" label="Vendor ID" />
            <TextField source="customerId" label="Customer ID" />

            <TextField source="modeOfPayment" label="Payment Mode" />
            <TextField source="bankTransactionId" label="Bank Transaction ID" />
            <TextField source="internalTransactionId" label="Internal Transaction ID" />

            <TextField source="amountReceived" label="Total Service amount" />
            <TextField source="commissionAmount" label="Commission Amount" />
            <TextField source="vendorEarning" label="Vendor Chargeable amount" />

            <TextField source="commissionPercentage" label="Commission Percentage" />
            <TextField source="commissionPaymentStatus" label="Commission Payment Status" />
            <TextField source="commissionTransactionID" label="Commission Transaction ID" />

            <TextField source="date" label="date" />
            <TextField source="serviceCategory" label="Service Category" />
            <TextField source="paymentStatus" label="Payment Status" />

            <TextField source="transactionId" label="Transaction ID" />
            <TextField source="mihPayId" label="mih Pay ID" />
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    )}
  </ShowController>
);

export default AccountShow;
